export default __webpack_public_path__ + "static/media/i_bus-jeonse_gy_tagless.498b27c9.svg";